import { RegisterWelcomeClient } from './registerWelcome.client';

export const registerWelcomeClientProvider = async (): Promise<void> => {
  const response = new RegisterWelcomeClient().post();

  return response as unknown as Promise<void>;
};
